import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { AccountModule } from './account/account.module';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { HttpInterceptors } from './core/interceptors';
import { RavenErrorHandler } from './core/interceptors/raven.interceptor';
import { LoginCallbackComponent } from './login/callback/login-callback.component';
import { LoginComponent } from './login/login/login.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LandingComponent } from './landing/landing.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgChartsModule } from 'ng2-charts';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { RouterlessTracking } from 'angulartics2';
import { Angulartics2Module } from 'angulartics2';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import CustomPrimeNgTheme from 'src/assets/theme/custom';

const appRoutes: Routes = [
  { path: '', component: LandingComponent },
  { path: 'login/callback', component: LoginCallbackComponent },
  { path: 'login', component: LoginComponent },
];

@NgModule({
  declarations: [AppComponent, LoginCallbackComponent, LoginComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    RouterModule.forRoot(appRoutes, {
      onSameUrlNavigation: 'reload',
      preloadingStrategy: PreloadAllModules,
      bindToComponentInputs: true,
    }),
    NgSelectModule,
    NgxDatatableModule,
    FormsModule,
    AccountModule,
    BrowserAnimationsModule,
    NgChartsModule,
    AngularSvgIconModule.forRoot(),
    Angulartics2Module.forRoot(),
  ],
  providers: [
    HttpInterceptors,
    { provide: ErrorHandler, useClass: RavenErrorHandler },
    RouterlessTracking,
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: CustomPrimeNgTheme,
        options: {
          // Currently we don't want our app to ever load in dark mode.
          // This is because we don't have a dark mode theme yet.
          // Once we have a dark mode theme, we can remove this selector.
          // To enable dark mode, add the class 'dark-mode-enabled' to the html element.
          darkModeSelector: '.dark-mode-enabled',
        },
      },
    }),
  ],
})
export class AppModule {}
